import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.5/js/sparta-events-utility";
import spartaGlobalFunctions from "utilities/global/sparta-global-functions-utility/2.1.3/js/sparta-global-functions-utility";
import spartaMediaQueryUtility from "utilities/global/sparta-mediaquery-utility/2.0.4/js/sparta-mediaquery-utility";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.1/js/sparta-store-utility";
import spartaStyleUtility from "utilities/global/sparta-style-utility/3.2.4/js/sparta-style-utility";
import _ from "utilities/vendor/lodash/4.17.21/js/lodash.custom.min";
import spartaUILayersUtility from "utilities/global/sparta-ui-layers-utility/5.7.7/js/sparta-ui-layers-utility";
import spartaBrowserSupportUtility from "utilities/global/sparta-browser-support-utility/4.5.2/js/sparta-browser-support-utility";
import spartaPolyfillUtility from "utilities/global/sparta-polyfill-utility/1.5.1/js/sparta-polyfill-utility";
import spartaRequireUtility from "utilities/global/sparta-require-utility/2.3.5/js/sparta-require-utility";
import spartaTemplatesUtility from "utilities/global/sparta-templates-utility/2.0.0/js/sparta-templates-utility";
/* global  */
/* eslint-disable require-jsdoc */
/* eslint-disable valid-jsdoc */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
/* eslint-disable no-console */

const EVENTS = {
  SPARTA_GLOBAL_READY: 'SPARTA_GLOBAL_READY.spartaBootstrapUtility',
  SPARTA_SECONDARY_READY: 'SPARTA_SECONDARY_READY.spartaBootstrapUtility',
  SPARTA_WINDOW_SCROLL: 'SPARTA_WINDOW_SCROLL.spartaBootstrapUtility',
};

class SpartaBootstrapUtility {
  constructor() {
    this.modules = [];
    this.initedModules = [];
    this.moduleInstances = [];
    this.appContainer = null;
    this.browser = spartaStoreUtility.getData('browser');
    this.loop = { total: 1, completed: 0 };
  }

  get EVENTS() {
    return EVENTS;
  }

  /**
   * @param {array<object>} requireArgs
   * bootstrap kickoff
   */
  init(requireArgs = [], widgetInfo) {
    this.setApplicationData(widgetInfo);
    this.checkForLangOverride();
    this.setupSpaParams(widgetInfo);    
    this.loadOptionsFromContainer();    
    this.setupGlobalEvents();
    this.createAndInitModules(requireArgs);
    this.clearResourceLoad();

    if (this.loop.total === 1) {
      spartaEventsUtility.pub(this.EVENTS.SPARTA_GLOBAL_READY);
    }
    if (this.loop.total === 2) {
      if (this.loop.completed === 0) {
        spartaEventsUtility.pub(this.EVENTS.SPARTA_GLOBAL_READY);
      } else if (this.loop.completed > 0) {
        spartaEventsUtility.pub(this.EVENTS.SPARTA_SECONDARY_READY);
      }
    }
  }

  setLoop(loopObj) {
    this.loop = loopObj;
  }

  clearResourceLoad() {
    if (spartaRequireUtility.getRequire().dependenciesMap) {
      spartaRequireUtility.getRequire().onResourceLoad = undefined;
    }
  }

  setupSpaParams(widgetInfo) {
    const spaParams = (widgetInfo && widgetInfo.name)
      ? window.spaWidgetParams[widgetInfo.name][widgetInfo.version]
      : window.spaParams;

    // set siteParams on spaParams if loading as a widget
    spaParams.siteParams = spaParams.siteParams || spaParams.params;
    const lang = (widgetInfo && widgetInfo.name) ? spartaStoreUtility.getData('lang').split('-')[0] : sparta.language;
    let language = lang ? lang : 'en';
    spaParams.language = language;
    spartaStoreUtility.addData('spaParams', spaParams);
    const bankHolidays = spaParams.global[spaParams.language]
      ? spaParams.global[spaParams.language].bankHolidays
      : null;
    if (bankHolidays) {
      spartaStoreUtility.addData('bankHolidays', bankHolidays);
    }
    spartaEventsUtility.pub(spartaEventsUtility.EVENTS.SPA_PARAMS_LOADED, spaParams);
  }

  setApplicationData(widgetInfo) {
    let appContainer;
    let mediaQueryContainer;

    const isWidget = !!(widgetInfo && widgetInfo.name && widgetInfo.version);
    spartaStoreUtility.addData('isWidget', isWidget);

    if (isWidget) {
      const widgetContainers = document.querySelectorAll(`[data-sparta-container="${widgetInfo.name}"][data-version="${widgetInfo.version}"]`);

      mediaQueryContainer = document.querySelector(`[data-sparta-wrapper="${widgetInfo.name}-${widgetInfo.version}"]`);

      if (widgetContainers) {
        // if only 1 container declared, set as a single object
        if (widgetContainers.length === 1) {
          [appContainer] = widgetContainers;
        } else if (widgetContainers.length > 1) {
          const widgetWithId = [...widgetContainers]
            .filter(el => el.getAttribute('data-id') === widgetInfo.id);
          appContainer = (widgetWithId && widgetWithId[0]) || widgetContainers;
        }
      }

      if (mediaQueryContainer && mediaQueryContainer.length) {
        [mediaQueryContainer] = mediaQueryContainer;
      }

      spartaStoreUtility.addData('applicationContext', widgetInfo);
    } else {
      // Sparta page loaded through Wealth Sparta Page Handler which injects mlGlobalData object containing csrfToken
      if (sparta.mlGlobalData) {
        spartaStoreUtility.addData('csrfToken', sparta.mlGlobalData.csrfToken);
      }
    }

    spartaEventsUtility.pub(spartaEventsUtility.EVENTS.APP_CONTEXT_LOADED, spartaStoreUtility.getData('applicationContext'));

    if (!appContainer) {
      let topContainer = document.querySelectorAll('[data-sparta-container]');
      mediaQueryContainer = document.querySelector('[data-sparta-wrapper]');

      if (!topContainer) {
        console.error('unable to find a sparta component - ensure data-sparta-container is set');
        return;
      }

      topContainer = [...topContainer]
        .filter(el => !el.classList.contains('sparta-widget-container'));
      if (topContainer.length !== 1) {
        console.error('too many containers on page, must use widget configuration or loader');
        return;
      }

      [appContainer] = topContainer;
    }

    this.appContainer = appContainer;
    spartaMediaQueryUtility.init(mediaQueryContainer || appContainer);

    this.appContainer = this.appContainer.length
      ? [].slice.call(this.appContainer)
      : this.appContainer;

    spartaStoreUtility.addData('applicationContainer', this.appContainer);
    spartaEventsUtility.pub(spartaEventsUtility.EVENTS.APP_CONTAINER_LOADED, appContainer);
  }

  /**
   * Loads application options/overrides into store from
   * appContainer.attr('data-sparta-overrides')
   */
  loadOptionsFromContainer() {
    const appContainer = spartaStoreUtility.getData('applicationContainer');
    const containers = [].slice.call(Array.isArray(appContainer) ? appContainer : [appContainer]);
    const optionsObj = JSON.parse(containers[containers.length - 1].getAttribute('data-sparta-options')) || {};
    spartaStoreUtility.addData('applicationOptions', optionsObj);
  }

  /**
   * Checks the application container if there is a language override.
   */
  checkForLangOverride() {
    const containers = spartaStoreUtility.getData('applicationContainer');
    const appContainer = [].slice.call(Array.isArray(containers) ? containers : [containers]);
    const langOverride = (
      appContainer && appContainer[appContainer.length - 1].getAttribute('data-sparta-lang')
    ) || null;

    if (langOverride) {
      spartaStoreUtility.addData('lang', langOverride.toLowerCase());
    }
  }

  /**
   * @param {array<object>} requireArgs
   * instantiate page modules
   */
  createModuleInstances(requireArgs) {
    const containers = spartaStoreUtility.getData('applicationContainer');
    const applicationContainer = Array.isArray(containers)
      ? containers[containers.length - 1]
      : containers;
    const boaModules = this._getUninitializedModules([...applicationContainer.querySelectorAll('[data-component="module"]')]);
    const deps = [...requireArgs];
    const depModuleMap = {};

    deps.forEach((dep) => {
      if (!dep || typeof dep.default !== 'function') {
        return;
      }
      const name = dep.default.toString().match(/^function\s*([^\s(]+)/)[1];
      depModuleMap[name] = dep;
    });

    boaModules.forEach((moduleDom) => {
      const className = moduleDom.getAttribute('data-init');

      if (className) {
        const module = depModuleMap[className];

        // set default options to empty object if no options were provided
        const options = JSON.parse(moduleDom.getAttribute('data-options')) || {};

        // pass module Node reference as target to module initialization
        options.target = moduleDom;

        // create module instance
        if (!this.moduleInstances[className]) {
          this.moduleInstances[className] = [];
        }
        if (typeof module !== 'undefined') {
          // eslint-disable-next-line new-cap
          this.moduleInstances[className].push(new module.default(options));
        }

        // we need to do this better, but goal is to remove this class after module initted
        // TODO maybe fire a custom event to hook into
        moduleDom.classList.remove('spa-module-init');
      }
    });

    spartaStoreUtility.addData('moduleInstances', this.moduleInstances);
  }

  /**
   * Verify if there are modules with dupliate IDs, rename the IDs to make them unique
   * @param {object} module
   */
  verifyUniqueModuleIds(module) {
    if (!module.settings.target || !module.settings.target.id) {
      return;
    }

    const moduleContainers = document.querySelectorAll(`[id="${module.settings.target.id}"]`);

    if (moduleContainers && moduleContainers.length > 1) {
      let imSettings;
      const mSettings = module.settings;
      this.initedModules.reverse().every((im) => {
        imSettings = im.module.settings;
        if (
          imSettings.moduleInfo
          && imSettings.moduleInfo.name === mSettings.moduleInfo.name
          && imSettings.target.id.startsWith(mSettings.target.id)
        ) {
          // increment the total instances
          mSettings.target.totalInstances = (imSettings.target.totalInstances || 0) + 1;

          // keep the totalInstances only with the last instance
          delete imSettings.target.totalInstances;

          // rename the module container ID
          mSettings.target.id += mSettings.target.totalInstances;
          return false;
        }
        return true;
      });
    }
  }

  /**
   * call init functions of all instantiated page modules
   */
  initModules() {
    this.modules.forEach((module) => {
      if (module.state === 'ready') {
        this.verifyUniqueModuleIds(module.module);

        module.module[module.init](module.args);
        module.state = 'initialized';
        this.initedModules.push(module);
      }
    });
  }

  /**
   * called by modules super
   * @param {object} module
   * @param {object} args
   * @param {string} init - name of function to be called in initModules
   */
  register(module, args = {}, init = 'init') {
    this.modules.push({
      state: 'ready',
      module,
      init,
      args,
    });
  }

  /**
   * trigger throttled spartaWindowScroll event
   */
  setupGlobalEvents() {
    // Scroll
    window.addEventListener('scroll', _.throttle((e) => {
      spartaEventsUtility.pub(this.EVENTS.SPARTA_WINDOW_SCROLL, [window.pageYOffset, e]);
    }, 20));
  }

  /**
   * run onloadHelpers for .spa-fn elements
   */
  onloadHelpers() {
    const containers = spartaStoreUtility.getData('applicationContainer');
    const applicationContainer = Array.isArray(containers)
      ? containers[containers.length - 1]
      : containers;

    // Find all elements with a .spa-fn class to run functions on
    const spaFnElems = this._getUninitializedModules([...applicationContainer.querySelectorAll('.spa-fn')]);
    if (!spaFnElems.length) {
      return;
    }

    const onloadHelperRegister = ['.spa-boa-window', '.spa-mobile-tel'];

    onloadHelperRegister.forEach((helperClass) => {
      if (helperClass === '.spa-mobile-tel' && !this.browser.mobile) {
        return;
      }
      const elsToProcess = this._getUninitializedModules(applicationContainer.querySelectorAll(`.spa-fn${helperClass}`));

      if (elsToProcess.length) {
        switch (helperClass) {
          case '.spa-boa-window':
            spartaUILayersUtility.addPopupWindowHelper(elsToProcess);
            break;
          case '.spa-mobile-tel':
            spartaGlobalFunctions.mobilePhoneFormatHelper(elsToProcess);
            break;
          default:
            break;
        }
      }
    }, this);
  }

  /**
   * Helper fn that, given a list of modules, only returns uninitialized modules
   */
  _getUninitializedModules(modules) {
    return _.filter(modules, module => !_.find(
      this.initedModules,
      initedModule => (initedModule.module.settings.target === module),
    ));
  }

  /**
   * @param {array<object>} requireArgs
   * Create and initialize modules
   */
  createAndInitModules(requireArgs) {
    // Initialize page modules
    this.createModuleInstances(requireArgs);
    this.initModules();

    // Init helpers associated with modules
    this.onloadHelpers();
  }
}

export default new SpartaBootstrapUtility();
